import { FormControl, MenuItem, OutlinedInput, Select, ThemeProvider } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

import { statutPaiementEnum } from '../../data/Interfaces';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useRole from '../../hooks/useRole';
import useUtilities from '../../hooks/useUtilities';
import { FieldComponentFont } from '../../Styles/componentStyles';
import { isFactureG, isHttpStatusSuccess } from '../../Utils/utils';

const ChangeStatusPaymentFacture = ({ facture, width, whoPays,getAllFacturesRefresh }) => {
    ChangeStatusPaymentFacture.propTypes = {
        facture: PropTypes.any,
        whoPays: PropTypes.any,
        width: PropTypes.any,
        getAllFacturesRefresh: PropTypes.func,
    };
    const axiosPrivate = useAxiosPrivate();
    const role = useRole();
    const { setSnackBarMessage,setIsSnackBarError, setOpenSnackBar } = useUtilities();
    const { i18n } = useTranslation();
    const [statusPaymentFacture, setStatusPaymentFacture] = useState();

    const defaultPaymentValue = () => {
        if (whoPays == 'client') {
            return facture?.statutPaimentClient;
        }
        else if (whoPays == 'expert') {
            return facture?.statutPaimentExpert;
        }
    };
    const [selectedPaymentStatus, setSelectedPaymentStatus] = useState(defaultPaymentValue());
    const updateStatutPaimentFacture = async (e) => {
        e.preventDefault();
        console.log('statusPaymentFacture',statusPaymentFacture);
        const newStatus = e.target.value;
        setSelectedPaymentStatus(newStatus);
        const datePickerElement = document.createElement('input');
        datePickerElement.setAttribute('type', 'date');
        datePickerElement.setAttribute('id', 'payment-date');
        datePickerElement.style.padding = '10px';
        datePickerElement.style.border = '1px solid #ccc';
        datePickerElement.style.borderRadius = '4px';
        datePickerElement.style.fontSize = '16px';
        datePickerElement.style.width = '80%';
        datePickerElement.style.fontFamily = 'Lato';
        let datePaymentExists = true;
        let response1;
        if(newStatus==='paye'){
            Swal.fire({
                title: i18n.t('Saisir la date du paiement'),
                //input: 'date',
                html:datePickerElement,
                inputAttributes: {
                    autocapitalize: 'off'
                },
                showCancelButton: true,
                confirmButtonText: 'Ok',
                cancelButtonText: i18n.t('Annuler'),
                confirmButtonColor: '#5CC889',
                cancelButtonColor: '#88898f',
                showLoaderOnConfirm: true,
                preConfirm: async () => {
                    try {
                        let payload;
                        const paymentDateInput = document.getElementById('payment-date');
                        const selectedDate = paymentDateInput.value;
                        // Use the selected date in your code

                        console.log('Selected date:', selectedDate);
                        if(!selectedDate || selectedDate == ''){
                            setSnackBarMessage(i18n.t('la date du paiement est un champs requis'));
                            setIsSnackBarError(true);
                            setOpenSnackBar(true);
                            datePaymentExists = false;
                        }
                        else{
                            if (whoPays == 'client') {
                                if (facture?.factureId || facture?.factureXId)
                                    payload = { 'statutPaimentClient': newStatus, type: 'facture',datePaimentClient:selectedDate };
                                else if (facture?.regularisationId || facture?.regularisationXId)
                                    payload = { 'statutPaimentClient': newStatus, type: 'regularisation',datePaimentClient:selectedDate  };
                                else if (isFactureG(facture?.refFacture))//facture?.factures?.length >0
                                    payload = {
                                        'type':'factureG',
                                        factureGId: facture?._id,
                                        datePaimentClient:selectedDate,
                                        'statutPaimentClient': newStatus,
                                    };
                            }
                            else if (whoPays == 'expert') {
                                if (facture?.factureId || facture?.factureXId)
                                    payload = { 'statutPaimentExpert': newStatus, type: 'facture',datePaimentExpert:selectedDate  };
                                else if (facture?.regularisationId || facture?.regularisationXId)
                                    payload = { 'statutPaimentExpert': newStatus, type: 'regularisation',datePaimentExpert:selectedDate  };
                            }
                            response1 = await axiosPrivate.post('/facture/updateStatutPaimentFacture',
                                {
                                    ...payload,
                                    [facture?.isCraOrCraX]: facture?.[facture?.isCraOrCraX]?._id, // we send craX or cra, and since one Cra has one facture .. so it's great for fraudes ..
                                }
                            );
                            const responseData1 = await response1.data;
                            console.log('submitresumeBackend', responseData1, responseData1?.message);
                            //Swal.fire('Done!', responseData1?.message, 'success');
                            setStatusPaymentFacture(newStatus);
                        }
                    }
                    catch (error) {
                        console.log(error.response?.status);
                        setSelectedPaymentStatus(defaultPaymentValue());
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: error.response.data?.error,
                            // footer: '<a href="">Why do I have this issue?</a>'
                        });
                    }
                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then((result) => {
                if(result.isConfirmed && datePaymentExists && isHttpStatusSuccess(response1?.status)){
                    Swal.fire({
                        //title: 'Done!',
                        text: i18n.t(response1?.data?.message),//'Le statut du paiement de la facture a été actualisé!',
                        icon: 'success',
                        showConfirmButton: true,
                    }).then(() => {
                        getAllFacturesRefresh();
                    });
                }
                else if (result.dismiss || !datePaymentExists) {
                    console.log('cancel');
                    setSelectedPaymentStatus(defaultPaymentValue());
                }
            });
        }
        else{
            try {
                let payload;
                if (whoPays == 'client') {
                    if (facture?.factureId || facture?.factureXId)
                        payload = { 'statutPaimentClient': newStatus, type: 'facture',datePaimentClient:null };
                    else if (facture?.regularisationId || facture?.regularisationXId)
                        payload = { 'statutPaimentClient': newStatus, type: 'regularisation',datePaimentClient:null };
                    else if (isFactureG(facture?.refFacture))
                        payload = {
                            'type':'factureG',
                            factureGId: facture?._id,
                            datePaimentClient: null,
                            'statutPaimentClient': newStatus,
                        };
                }
                else if (whoPays == 'expert') {
                    if (facture?.factureId || facture?.factureXId)
                        payload = { 'statutPaimentExpert': newStatus, type: 'facture',datePaimentExpert:null };
                    else if (facture?.regularisationId || facture?.regularisationXId)
                        payload = { 'statutPaimentExpert': newStatus, type: 'regularisation',datePaimentExpert:null};
                }
                response1 = await axiosPrivate.post('/facture/updateStatutPaimentFacture',
                    {
                        ...payload,
                        [facture?.isCraOrCraX]: facture?.[facture?.isCraOrCraX]?._id, // we send craX or cra, and since oneCra has one facture .. so it's great for fraudes ..
                    }
                );
                const responseData1 = await response1.data;
                console.log('backend message', {responseData1, response1,} );
                if (isHttpStatusSuccess(response1?.status)) {
                    setStatusPaymentFacture(newStatus);
                    Swal.fire('Done!',
                        response1?.data?.message ,
                        // 'Le statut du paiement de la facture a été actualisé!',
                        'success').then(() => getAllFacturesRefresh());
                }
            }
            catch (error) {
                console.log(error.response?.status);
                setSelectedPaymentStatus(defaultPaymentValue());
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: i18n.t(error.response.data?.error),
                    // footer: '<a href="">Why do I have this issue?</a>'
                });
            }
        }
    };

    return (
        <ThemeProvider theme={FieldComponentFont}>
            <FormControl
                variant="outlined"
                style={{ width: width }}
            >
                <Select
                    labelId="demo-multiple-name-label"
                    id="demo-multiple-name"
                    input={<OutlinedInput />}
                    sx={{
                        '& > :not(style)': { borderRadius: '8px' },
                    }}
                    disabled={(facture?.Statut=='proformat' || role == 'client' || role == 'expert')}
                    defaultValue={defaultPaymentValue()}
                    //value={statusPaymentFacture}
                    value={selectedPaymentStatus}
                    onChange={updateStatutPaimentFacture}
                    style={{ backgroundColor: 'white', width: width ,borderRadius: '8px'}}
                >
                    {statutPaiementEnum.map((option, i) => {
                        return (
                            <MenuItem
                                style={{ width: width }}
                                key={i}
                                value={option.value}
                            >
                                {i18n.t(option?.label)}
                            </MenuItem>
                        );
                    })}
                </Select>
            </FormControl>
        </ThemeProvider>
    );
};

export default ChangeStatusPaymentFacture;